import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgChatWithStars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 166 98"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M78.14 79.298V82l16.433-11.1h-4l-12.434 8.398ZM104 70.9h4c5.523 0 10-4.477 10-10V37c0-5.523-4.477-10-10-10h-4c5.523 0 10 4.477 10 10v23.9c0 5.522-4.477 10-10 10Z"
      fill="#E1F3FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72 48a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm24 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      fill="#17181A"
    />
    <path d="M95 56s-10.67 4-21 0" stroke="#17181A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10 16-5.878 3.09 1.123-6.545L.489 7.91l6.572-.955L10 1l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545L10 16Zm142 5.559L143.348 26 145 16.593l-7-6.662 9.674-1.372L152 0l4.326 8.559L166 9.93l-7 6.662L160.652 26 152 21.559ZM127.5 95.95 123.483 98l.767-4.342-3.25-3.074 4.491-.634L127.5 86l2.009 3.95 4.491.634-3.25 3.074.767 4.342-4.017-2.05Z"
      fill="#E6F2FF"
    />
    <path
      d="M94.573 70.4a.5.5 0 0 0-.28.085l-.822.555.28.414-1.643 1.11-.28-.414-1.643 1.11.28.414-1.644 1.11-.28-.414-1.643 1.11.28.415-1.644 1.11-.28-.415-1.643 1.11.28.415-1.643 1.11-.28-.414-1.644 1.11.28.414-1.643 1.11-.28-.414-.066.044h-.476v-1.85h.5v-1.85h-.5v-1.85h.5v-1.85h-.5v-1.85h.5v-.926h-1.508v-.5h-2.015v.5H73.1v-.5h-2.015v.5H69.07v-.5h-2.016v.5H65.04v-.5h-2.016v.5h-2.015v-.5H60a9.63 9.63 0 0 1-.932-.045l-.049.498a9.952 9.952 0 0 1-1.923-.38l.145-.48a9.437 9.437 0 0 1-1.72-.713l-.236.441a9.974 9.974 0 0 1-1.629-1.09l.317-.387a9.56 9.56 0 0 1-1.317-1.317l-.386.317c-.415-.504-.78-1.05-1.091-1.629l.44-.236a9.43 9.43 0 0 1-.712-1.72l-.479.145a9.952 9.952 0 0 1-.38-1.923l.497-.049a9.63 9.63 0 0 1-.045-.932v-.996H50v-1.991h.5V55.92H50v-1.99h.5v-1.992H50v-1.992h.5v-1.991H50v-1.992h.5v-1.991H50V41.98h.5v-1.992H50v-1.991h.5V37c0-.315.015-.626.045-.932l-.498-.048a9.951 9.951 0 0 1 .381-1.924l.479.145c.182-.6.422-1.176.713-1.72l-.441-.236c.31-.58.676-1.125 1.09-1.629l.387.317c.395-.48.837-.922 1.317-1.317l-.317-.386a9.988 9.988 0 0 1 1.63-1.091l.235.44a9.437 9.437 0 0 1 1.72-.712l-.145-.479a9.952 9.952 0 0 1 1.923-.38l.049.497A9.63 9.63 0 0 1 60 27.5h1V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h2V27h2v.5h1c.315 0 .626.015.932.045l.049-.498a9.953 9.953 0 0 1 1.923.381l-.145.479c.6.182 1.176.421 1.72.713l.236-.441c.579.31 1.125.676 1.629 1.09l-.317.387c.481.395.922.837 1.317 1.317l.386-.317c.415.504.781 1.05 1.091 1.63l-.441.235c.292.544.531 1.12.713 1.72l.479-.145c.187.618.316 1.261.381 1.924l-.498.048c.03.306.045.617.045.932v.996h.5v1.991h-.5v1.992h.5v1.992h-.5v1.991h.5v1.992h-.5v1.991h.5v1.992h-.5v1.992h.5v1.991h-.5v1.992h.5v1.991h-.5v.996c0 .315-.015.626-.045.932l.498.049a10.012 10.012 0 0 1-.381 1.923l-.479-.145a9.394 9.394 0 0 1-.713 1.72l.441.236a9.943 9.943 0 0 1-1.091 1.63l-.386-.318c-.395.48-.836.922-1.317 1.317l.317.387c-.504.414-1.05.78-1.629 1.09l-.236-.44a9.45 9.45 0 0 1-1.72.713l.145.478a9.953 9.953 0 0 1-1.923.38l-.049-.497c-.306.03-.617.045-.932.045v.5h-.959v-.5h-1.918v.5h-1.918v-.5h-1.919v.5h-1.918v-.5H97.45v.5h-1.918v-.5h-.96Z"
      stroke="#C2C5CC"
      strokeLinejoin="round"
      strokeDasharray={2}
    />
  </svg>
);
const Memo = memo(SvgChatWithStars);
export default Memo;
